import type { IssueTrackerProvider } from '../data/projectTypes'

export const PROVIDERS: { id: IssueTrackerProvider; label: string }[] = [
  { id: 'github', label: 'GitHub Issues' },
  { id: 'gitlab', label: 'GitLab Issues' },
  { id: 'linear', label: 'Linear' },
  { id: 'jira', label: 'Jira' },
  { id: 'asana', label: 'Asana' },
]

// The token label + help text per provider, so the single API-token field explains exactly what to paste.
export const TOKEN_HELP: Record<IssueTrackerProvider, { label: string; hint: string }> = {
  github: {
    label: 'GitHub access token',
    hint: 'A personal access token with "repo" (or Issues: read & write) scope on the repository.',
  },
  gitlab: {
    label: 'GitLab access token',
    hint: 'A personal (or project) access token with the "api" scope and at least Reporter access to the project.',
  },
  linear: {
    label: 'Linear API key',
    hint: 'A personal API key from Linear → Settings → Security & access → Personal API keys.',
  },
  jira: {
    label: 'Jira API token',
    hint: 'An API token from id.atlassian.com → Security → API tokens, paired with your account email.',
  },
  asana: {
    label: 'Asana personal access token',
    hint: 'A personal access token from the Asana developer console (app.asana.com/0/my-apps), for an account that can add tasks to the project.',
  },
}
